import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_xlsx_export_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "exportXlsxModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "row",
  style: {"margin-bottom":"25px"}
}
const _hoisted_6 = ["value", "label"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card-footer d-flex justify-content-end" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h2", { class: "fw-bolder" }, "Download Excel Report")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "fw-bold form-label",
              for: "selectYearXlsx"
            }, " Export Year: ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              id: "selectYearXlsx",
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearsList, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item,
                  label: item
                }, null, 8, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedYear]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              class: "fw-bold form-label",
              for: "selectYearXlsx"
            }, " Report Type: ", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedReportType) = $event)),
              class: "form-control",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeReportType()))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("option", {
                selected: "",
                value: "iii"
              }, " Inclusion Impact Index ", -1),
              _createElementVNode("option", { value: "sp" }, " Inclusion Plus ", -1),
              _createElementVNode("option", { value: "iii-sp" }, " General ", -1)
            ]))], 544), [
              [_vModelSelect, _ctx.selectedReportType]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onHideModal && _ctx.onHideModal(...args)))
          }, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-dark-blue",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmitModal && _ctx.onSubmitModal(...args)))
          }, [
            (_ctx.spinnerDownloadVisible)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createTextVNode(" Download ", -1))
          ])
        ])
      ])
    ])
  ], 512))
}